/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable consistent-return */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-underscore-dangle */
import React, {
  useState, useContext, useMemo, useEffect,
} from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';

import { withTranslation } from 'language/i18n';
import { getObjectByLanguage } from 'language/helpers';

import { getMachine, getSampleMachinery } from 'models/machinery';

import { UserContext } from 'contexts/userContext';

import { getSliderMedias, getReportContentsMediasGroupByField } from 'utils/machineMediaHelpers';

import { MACHINE_STATE, TEMPLATE_TYPE } from 'constants/common';

import Layout from 'components/partials/Layout';
import Breadcrumb from 'components/Breadcrumb';
import useMachineryHandler from './hooks/useMachineryHandler';
import CounterOffer from './components/productDetail/CounterOffer';
import MachinerySlider from './components/productDetail/MachinerySlider';
import Gallery from './components/productDetail/Gallery';
import DownloadReportModal from './components/productDetail/DownloadReportModal';
import HowToAuctionWorkModal from './components/productDetail/HowToAuctionWorkModal';
// import AuctionNotification from './components/productDetail/AuctionNotification';
import MarketPlaceModal from './components/productDetail/marketPlaceModals/MarketPlaceModal';
import BidStatusModal from './components/productDetail/marketPlaceModals/BidStatusModal';
import CheckBidModal from './components/productDetail/marketPlaceModals/CheckBidModal';
import CounterOfferModal from './components/productDetail/marketPlaceModals/CounterOfferModal';
import ContactWithCustomerModal from './components/productDetail/ContactWithCustomerModal';
import TooltipRate from './components/productDetail/TooltipRate';
import ContentBodyV2 from './components/productDetail/v2/ContentBody';
import ContentBody from './components/productDetail/ContentBody';

const ProductDetailPage = ({
  t, machine: ssrMachine, inEventMachines, upcomingMachines, soldMachines,
}) => {
  const { userData } = useContext(UserContext);
  const user = userData;

  const {
    machine,
    contactWithCustomerModalVisible,
    machineSoldPrice,
    counterOfferData,
    offers,
    minimumIncrement,
    offerPlacedResponse,
    counterOfferPlacedResponse,
    setOfferPlacedResponse,
    setCounterOfferPlacedResponse,
    setCounterOfferData,
    setContactWithCustomerModalVisible,
  } = useMachineryHandler({ machine: ssrMachine });

  const [downloadReportModalVisible, setDownloadReportModalVisible] = useState(false);
  const [howToAuctionWorkModalVisible, setHowToAuctionWorkModalVisible] = useState(false);
  const [galleryContent, setGalleryContent] = useState({});
  const [tooltipPosition, setTooltipPosition] = useState({});
  const [marketPlaceModalVisible, setMarketPlaceModalVisible] = useState(false);
  const [bidStatusModalData, setBidStatusModalData] = useState({});
  const [checkBidModalData, setCheckBidModalData] = useState({});
  const [counterOfferModalVisible, setCounterOfferModalVisible] = useState(false);

  const ContentBodyComponent = useMemo(() => {
    return machine.report.template.type === TEMPLATE_TYPE.GENERAL ? ContentBodyV2 : ContentBody;
  }, [machine]);

  const sliderMedias = useMemo(() => getSliderMedias(machine.report), [machine]);
  const reportContentsMediasGroupedByCategoryName = useMemo(
    () => getReportContentsMediasGroupByField(machine.report.contents, 'question.category.name').groupByField,
    [machine],
  );

  const breadcrumbs = [
    {
      label: t('homepage'),
      url: '/',
    },
    {
      label: t('machinery'),
      url: '/machinery',
    },
    {
      label: getObjectByLanguage(machine.title),
      url: `/machinery/${machine.id}`,
    },
  ];

  const contentBodyProps = {
    machine,
    offers,
    machineSoldPrice,
    setGalleryContent,
    setDownloadReportModalVisible,
    setTooltipPosition,
    setHowToAuctionWorkModalVisible,
    setMarketPlaceModalVisible,
    setCheckBidModalData,
    minimumIncrement,
    sliderMedias,
    reportContentsMediasGroupedByCategoryName,
  };

  useEffect(() => {
    setContactWithCustomerModalVisible(false);
    setDownloadReportModalVisible(false);
    setHowToAuctionWorkModalVisible(false);
    setGalleryContent({});
    setTooltipPosition({});
    setMarketPlaceModalVisible(false);
    setBidStatusModalData({});
    setCheckBidModalData({});
    setCounterOfferModalVisible(false);
  }, [machine.id]);

  return (
    <>
      <main className="has-header">
        {/*  <AuctionNotification /> */}
        <div className="container">
          <div className="row mt-4 mb-4 mt-lg-3 mb-lg-3">
            <div className="col">
              <Breadcrumb links={breadcrumbs} />
            </div>
          </div>
          <CounterOffer
            data={counterOfferData}
            setData={setCounterOfferData}
            setCounterOfferModalVisible={setCounterOfferModalVisible}
          />
          <div className="row mb-4">
            <ContentBodyComponent {...contentBodyProps} />
          </div>
          {!isEmpty(inEventMachines) && (
            <MachinerySlider
              machines={inEventMachines}
              title={t('suggestionsForYou')}
            />
          )}
          {!isEmpty(soldMachines) && (
            <MachinerySlider
              machines={soldMachines}
              title="Henüz Satılanlar"
            />
          )}
          {!isEmpty(upcomingMachines) && (
            <MachinerySlider
              machines={upcomingMachines}
              title="Yakında Satışta"
            />
          )}
        </div>
        {!isEmpty(galleryContent) && (
          <Gallery
            galleryContent={galleryContent}
            setGalleryContent={setGalleryContent}
            mediasGroupedByCategoryName={reportContentsMediasGroupedByCategoryName}
            machineTitle={getObjectByLanguage(machine.title)}
          />
        )}
      </main>
      {downloadReportModalVisible && (
        <DownloadReportModal
          visible={downloadReportModalVisible}
          setVisible={setDownloadReportModalVisible}
          reportPdfUrl={machine.report.pdf}
        />
      )}
      {howToAuctionWorkModalVisible && (
        <HowToAuctionWorkModal
          visible={howToAuctionWorkModalVisible}
          setVisible={setHowToAuctionWorkModalVisible}
        />
      )}
      {!isEmpty(tooltipPosition) && (
        <TooltipRate
          position={tooltipPosition}
        />
      )}
      {marketPlaceModalVisible && (
        <MarketPlaceModal
          machine={machine}
          visible={marketPlaceModalVisible}
          setVisible={setMarketPlaceModalVisible}
          offers={offers}
          setCheckBidModalData={setCheckBidModalData}
          setHowToAuctionWorkModalVisible={setHowToAuctionWorkModalVisible}
          minimumIncrement={minimumIncrement}
          user={user}
        />
      )}
      {contactWithCustomerModalVisible && (
        <ContactWithCustomerModal
          visible={contactWithCustomerModalVisible}
          setVisible={setContactWithCustomerModalVisible}
        />
      )}
      {counterOfferModalVisible && (
        <CounterOfferModal
          machine={machine}
          visible={counterOfferModalVisible}
          setVisible={setCounterOfferModalVisible}
          counterOfferData={counterOfferData}
          setHowToAuctionWorkModalVisible={setHowToAuctionWorkModalVisible}
          setCounterOfferData={setCounterOfferData}
          setCounterOfferPlacedResponse={setCounterOfferPlacedResponse}
          counterOfferPlacedResponse={counterOfferPlacedResponse}
        />
      )}
      {!isEmpty(checkBidModalData) && (
        <CheckBidModal
          machine={machine}
          setMarketPlaceModalVisible={setMarketPlaceModalVisible}
          data={checkBidModalData}
          setData={setCheckBidModalData}
          setBidStatusModalData={setBidStatusModalData}
          setOfferPlacedResponse={setOfferPlacedResponse}
          offerPlacedResponse={offerPlacedResponse}
        />
      )}
      {!isEmpty(bidStatusModalData) && (
        <BidStatusModal
          machine={machine}
          offers={offers}
          data={bidStatusModalData}
          setData={setBidStatusModalData}
          user={user}
        />
      )}
    </>
  );
};

ProductDetailPage.propTypes = {
  t: PropTypes.func,
  machine: PropTypes.object,
  inEventMachines: PropTypes.array,
  upcomingMachines: PropTypes.array,
  soldMachines: PropTypes.array,
};

export const getServerSideProps = async ({ params, res }) => {
  try {
    const { id } = params;

    const { machine } = await getMachine(id);
    const { sampleMachines } = await getSampleMachinery(5);

    return {
      props: {
        blackHeader: true,
        headTitle: getObjectByLanguage(machine.title),
        machine,
        inEventMachines: sampleMachines?.[MACHINE_STATE.IN_EVENT] || [],
        upcomingMachines: sampleMachines?.[MACHINE_STATE.WAITING_EVENT_DATE] || [],
        soldMachines: sampleMachines?.[MACHINE_STATE.SOLD] || [],
      },
    };
  } catch (error) {
    res.writeHead(302, { Location: '/' });
    res.end();
  }
};

/* export const getStaticProps = async ({ params }) => {
  const { id } = params;

  const { machines } = await getMachinery();
  const { machine } = await getMachine(id);

  return {
    props: {
      blackHeader: true,
      headTitle: 'Product Detail Page',
      machine,
      machines,
    },
  };
};

export const getStaticPaths = async () => {
  const { machines } = await getMachinery();

  const paths = _.map(machines, (machine) => {
    return {
      params: {
        id: machine.id,
        machines,
      },
    };
  });

  return {
    fallback: true,
    paths,
  };
}; */

ProductDetailPage.Layout = Layout;

export default withTranslation('common')(ProductDetailPage);
